class Customer.SignaturePreviewView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/signatures/preview"]

  initialize: ({container, text, text_html})->
    @$el = container
    @text = text_html || text
    @render()

  render: ->
    @$el.html(@template({ text: @text }))
    @$el.find('#preview-close').on('click', @, @closeModal)
    @$el.find('#preview-accept').on('click', @, @closeModal)
    @$el.find('#signature-preview').modal('show')

  closeModal: =>
    @$el.find('#signature-preview').modal('hide')
